import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Folder from './icon-folder.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Folder {...validProps} />;
}
SvgComponent.iconName = 'folder';

/**
 * @deprecated This is a legacy icon
 */
export const FolderIcon = svgIconWrapper(SvgComponent);
